module.exports = __webpack_public_path__ + "static/media/layer-plus.a8e442fa.svg";